import React, { FC } from 'react';
import cn from 'classnames';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.scss';

export interface IDate extends ReactDatePickerProps {
  className?: string;
  label?: string | JSX.Element;
  error?: string | JSX.Element;
  dateValue?: Date;
  placeholder?: string;
}

const Date: FC<IDate> = ({
  className,
  dateFormat = 'dd.MM.yyyy',
  dateValue,
  dropdownMode = 'select',
  error,
  label,
  ...rest
}) => (
  <>
    {label || null}
    <DatePicker
      className={cn('hbh-date', className)}
      selected={dateValue}
      shouldCloseOnSelect
      dateFormatCalendar="MMMM"
      dateFormat={dateFormat}
      dropdownMode={dropdownMode}
      {...rest}
    />
    {error || null}
  </>
);

export default Date;
